<div *ngIf="!job.groupedByType" class="col layout-row gap-5"
     (click)="onClick($event)"
     (mouseenter)="isShowObligateTimeWindowToggle=true"
     (mouseleave)="isShowObligateTimeWindowToggle=false"
     (contextmenu)="openContextMenu($event)"
     [ngClass]="{
       'selected': isSelected,
       'locked': (job.lockedRouteId || route?.locked || isRunning),
       'fit-content': !isChild,
       'out-of-draft': !!job.excluded,
     }">

  <div *ngIf="draft" class="layout-column gap-10 indications">

    <div class="flex layout-column layout-align-center-center gap-5 position-relative">

      <ng-container *ngIf="!isChild">
        <ng-container *ngTemplateOutlet="dragHandleTemplate"></ng-container>
      </ng-container>

      <bringoz-icon *ngIf="(job.lockedRouteId || route?.locked || isRunning)"
                    class="margin-right-5"
                    iconName="lock"
                    classSize="lg"
                    fill="#484848"
                    [ngbTooltip]="'Job is Locked' | translate"
                    container="body"
                    openDelay="300">

      </bringoz-icon>

      <!--Indexes In Route-->
      <div *ngIf="job.routed" class="index-in-route-container"
           [style.border-color]="routeColor">
        <div *ngFor="let indexInRoute of indexesInRoute;"
             [ngClass]="{'highlighted': indexInRoute.isHighlighted}"
             [style.background]="indexInRoute.isHighlighted ? routeColor : (routeColor + 20)"
             [style.color]="indexInRoute.isHighlighted ? 'white' : routeColor"
             [style.border-color]="routeColor"
             [ngbTooltip]="'Activity Index: ' + indexInRoute.index"
             placement="right"
             container="body"
             openDelay="300">
          {{ indexInRoute.index }}
        </div>
      </div>

    </div>

  </div>

  <div class="flex layout-row layout-wrap info-container">

    <!--Link Row-->
    <div class="flex-100 layout-row layout-align-start-center">

      <div class="flex layout-row layout-align-start-center id-row" *ngIf="settings?.columns?.id">
        <app-bringoz-checkbox *ngIf="!isChild && !isHideSelect && !route?.locked && !isRunning"
                              appBringozIdGenerator="checkbox-service-service-panel"
                              [isChecked]="isSelected"
                              [ngbTooltip]="isSelected ? ('Deselect Job' | translate) : ('Select Job' | translate)"
                              openDelay="300"
                              (clickEvent)="onToggleEvent($event)">
        </app-bringoz-checkbox>

        <app-bringoz-state-link *ngIf="job.orderId"
                                class="text-ellipsis"
                                [state]="'order.info'"
                                [params]="{id : job.orderId}"
                                [permission]="'oms.orders.get'"
                                [text]="job.externalId || job.orderId">
        </app-bringoz-state-link>

        <app-bringoz-status-tag *ngIf="job.isAbortedService"
                                class="margin-left-5 margin-right-5"
                                status="Aborted"
                                [isSmall]="true">

        </app-bringoz-status-tag>

        <!--      <app-bringoz-state-link *ngIf="job.fulfillmentId"-->
        <!--                              class="text-ellipsis"-->
        <!--                              [state]="'fulfillment'"-->
        <!--                              [params]="{id : job.fulfillmentId}"-->
        <!--                              [permission]="'fulfillment.service.list'"-->
        <!--                              [text]="job.fulfillmentId">-->
        <!--      </app-bringoz-state-link>-->

        <span *ngIf="!job.orderId" class="br-body-1 fulfillment-id">{{ job.fulfillmentId || '---' }}</span>
        <bringoz-button type="tertiary"
                        size="fit"
                        appBringozIdGenerator="service-info-service-service-panel"
                        [ngbTooltip]="'View Job Details' | translate"
                        openDelay="300"
                        (onClick)="onViewJob.emit({jobs: [job], event: $event})">
          <bringoz-icon iconName="info-outline" classSize="md" fill="#484848"></bringoz-icon>
        </bringoz-button>

        <bringoz-icon *ngIf="job.lastSyncedFromStepAt"
                      iconName="synced"
                      classSize="md"
                      [ngbTooltip]="('Synced' | translate) + ': ' + (job | bringozFullDate: 'lastSyncedFromStepAt') + ' ' + (job | bringozTime: 'lastSyncedFromStepAt')"
                      openDelay="300">
        </bringoz-icon>

        <span class="flex"></span>

        <div *ngIf="(isShowObligateTimeWindowToggle || isObligatedTimeWindow) && !!draft"
             type="tertiary"
             class="pointer"
             (mouseenter)="isHighlightObligateTimeWindowToggle=true"
             (mouseleave)="isHighlightObligateTimeWindowToggle=false"
             appBringozIdGenerator="priority-service-service-panel"
             (click)="onToggleObligateTimeWindow.emit({jobIds: [job.id], obligateTimeWindow: !isObligatedTimeWindow})">

          <div *ngIf="isHighlightObligateTimeWindowToggle">
            <bringoz-icon *ngIf="isObligatedTimeWindow" iconName="toggle-on-hover"
                          [ngbTooltip]="'Guarantee' | translate"
                          openDelay="300"
                          triggers="hover"
                          container="body"></bringoz-icon>
            <bringoz-icon *ngIf="!isObligatedTimeWindow"
                          iconName="toggle-off-hover"
                          [ngbTooltip]="'Set Guarantee' | translate"
                          openDelay="300"
                          triggers="hover"
                          container="body"></bringoz-icon>
          </div>

          <div *ngIf="!isHighlightObligateTimeWindowToggle">
                      <bringoz-icon *ngIf="isObligatedTimeWindow" iconName="toggle-on"
                        [ngbTooltip]="'Guarantee' | translate"
                        openDelay="300"></bringoz-icon>
          <bringoz-icon *ngIf="!isObligatedTimeWindow" iconName="toggle-off"
                        [ngbTooltip]="'Set Guarantee' | translate"
                        openDelay="300"></bringoz-icon>
          </div>

        </div>

        <div *ngIf="job && job.splitSuggestionType" class="split-suggestions layout-row gap-5 pointer"
             [ngbTooltip]="(job.splitSuggestionType === SplitSuggestionType.SPLIT_PACKAGES ? 'JobSplit.ByPackagesTooltip' : 'JobSplit.ByLocationTooltip') | translate"
             [class.lockSplit]="job.lockedRouteId || route?.locked || route?.actionProcess?.running"
             placement="top"
             container="body"
             (click)="reverseJobSplit($event)">
          <bringoz-icon iconName="{{job.splitSuggestionType === SplitSuggestionType.SPLIT_PACKAGES ? 'BOX' : 'location-pin-outline'}}" classSize="md" fill="#484848"></bringoz-icon>
          <bringoz-icon iconName="route-split" classSize="md" fill="#484848"></bringoz-icon>
        </div>

        <app-planning-draft-job-action-menu
          [job]="job"
          (onOpen)="onContextMenu.emit({job: job, event: $event})">
        </app-planning-draft-job-action-menu>

        <!--        <ng-content></ng-content>-->
      </div>

    </div>

    <!--Address Row-->
    <div *ngIf="settings?.columns?.address && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">
      <!--Stops Address-->
      <div class="flex layout-row layout-align-start-center gap-5 text-ellipsis"
           *ngFor="let stop of job.stops">
        <!--        <bringoz-icon iconName="location-pin-outline"-->
        <!--                      classSize="md"-->
        <!--                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"-->
        <!--                      [ngbTooltip]="'Address' | translate"-->
        <!--                      openDelay="300">-->
        <!--        </bringoz-icon>-->
        <app-task-purpose [purpose]="stop.stopType" firstLetterOnly="true"></app-task-purpose>
        <div class="flex td small layout-row layout-align-start-center"
             (mouseenter)="onToggleIsShowAddressIcon(job.id + '-' + stop.stopType, true)"
             (mouseleave)="onToggleIsShowAddressIcon(job.id + '-' + stop.stopType, false)">

          <div *ngIf="!stop.depotSyncId" class="flex layout-row layout-align-start-center">

          <span [appBringozTooltip]="locationTooltip"
                [applyHoverColor]="true"
                ngbTooltip class="br-body-1 text-ellipsis">
            {{ stop.address | bringozAddress }}
          </span>

            <app-address-quality
              *ngIf="isValidAddressType(stop.address) && (isShowAddressIcon[job.id + '-' + stop.stopType] || !isHighQualityAddress(stop.address))"
              [address]="stop.address.addressResolvingInfo" [query]="query"
              [type]="type">
            </app-address-quality>
          </div>

          <ng-template #locationTooltip>
            <div class="layout-column layout-align-start-center">
              <div class="layout-column layout-align-start-center">
                <span class="br-body-2">{{ 'Address' | translate }}
                  : {{ stop.address | bringozAddress }}</span>
                <div class="layout-column layout-align-start-center">
                  <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}
                    : {{ stop.address.floor || '--' }}</span>
                  <span class="br-body-2">{{ 'Apt' | translate }}: {{
                      stop.address.apartment || '--'
                    }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

    </div>

    <ng-container *ngIf="settings?.columns?.address && !!itemElementSize">
      <!--Stops Address-->
      <div class="layout-row layout-align-start-center text-ellipsis  gap-5"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let stop of job.stops">
        <!--        <bringoz-icon iconName="location-pin-outline"-->
        <!--                      classSize="md"-->
        <!--                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"-->
        <!--                      [ngbTooltip]="'Address' | translate"-->
        <!--                      openDelay="300">-->

        <!--        </bringoz-icon>-->
        <app-task-purpose [purpose]="stop.stopType" firstLetterOnly="true"></app-task-purpose>
        <div class="flex td small layout-row layout-align-start-center"
             (mouseenter)="onToggleIsShowAddressIcon(job.id + '-' + stop.stopType, true)"
             (mouseleave)="onToggleIsShowAddressIcon(job.id + '-' + stop.stopType, false)">

          <div *ngIf="!stop.depotSyncId" class="flex layout-row layout-align-start-center">

          <span [appBringozTooltip]="locationTooltip"
                [applyHoverColor]="true"
                ngbTooltip class="br-body-1 text-ellipsis">
            {{ stop.address | bringozAddress }}
          </span>

            <app-address-quality
              *ngIf="isValidAddressType(stop.address) && (isShowAddressIcon[job.id + '-' + stop.stopType] || !isHighQualityAddress(stop.address))"
              [address]="stop.address.addressResolvingInfo" [query]="query"
              [type]="type">
            </app-address-quality>
          </div>

          <ng-template #locationTooltip>
            <div class="layout-column layout-align-start-center">
              <div class="layout-column layout-align-start-center">
                <span class="br-body-2">{{ 'Address' | translate }}
                  : {{ stop.address | bringozAddress }}</span>
                <div class="layout-column layout-align-start-center">
                  <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}
                    : {{ stop.address.floor || '--' }}</span>
                  <span class="br-body-2">{{ 'Apt' | translate }}: {{
                      stop.address.apartment || '--'
                    }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!--Time Window Row-->
    <div *ngIf="settings?.columns?.timeWindow && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">

      <!--Stops Time Window-->
      <div class="flex layout-row layout-align-start-center gap-5 text-ellipsis"
           *ngFor="let stop of job.stops">
        <bringoz-icon iconName="time-window-outline"
                      classSize="md"
                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Time Window' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ stop | timeWindow }}</span>

      </div>

    </div>

    <ng-container *ngIf="settings?.columns?.timeWindow && !!itemElementSize">
      <!--Stops Time Window-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-5 "
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let stop of job.stops">
        <bringoz-icon iconName="time-window-outline"
                      classSize="md"
                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Time Window' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ stop | timeWindow }}</span>

      </div>
    </ng-container>

    <!--Contacts Row-->
    <div *ngIf="settings?.columns?.contacts && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">
      <!--Stops Contacts-->
      <div class="layout-row layout-align-start-center gap-5 text-ellipsis flex"
           *ngFor="let stop of job.stops">
        <bringoz-icon iconName="contact-circle"
                      classSize="md"
                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Contact' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ stop.contact?.name || '---' }}</span>

      </div>
    </div>

    <ng-container *ngIf="settings?.columns?.contacts && !!itemElementSize">
      <!--Stops Contacts-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-5 "
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let stop of job.stops">
        <bringoz-icon iconName="contact-circle"
                      classSize="md"
                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Contact' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ stop.contact?.name || '---' }}</span>

      </div>
    </ng-container>

    <!--Service Time Row-->
    <div *ngIf="settings?.columns?.serviceTime && !itemElementSize"
         class="flex-100 layout-row layout-align-start-center info-row">

      <!--Stops Time Window-->
      <div class="flex layout-row layout-align-start-center gap-5 text-ellipsis"
           *ngFor="let stop of job.stops">
        <bringoz-icon iconName="timer-outline"
                      classSize="md"
                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Service Time' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!stop.detailedServiceTime"
              class="br-body-1 text-ellipsis">
          {{ stop.serviceTimeMillis | bringozTimeConvert:true }}
        </span>

        <app-task-detailed-service-time *ngIf="!!stop.detailedServiceTime"
                                        [fontSize]="'br-body-1'"
                                        [isAllowEdit]="false"
                                        [detailedServiceTime]="stop.detailedServiceTime">
        </app-task-detailed-service-time>

      </div>

    </div>

    <ng-container *ngIf="settings?.columns?.serviceTime && !!itemElementSize">
      <!--Stops Time Window-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-5 "
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           *ngFor="let stop of job.stops">
        <bringoz-icon iconName="timer-outline"
                      classSize="md"
                      [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                      [ngbTooltip]="'Service Time' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!stop.detailedServiceTime"
              class="br-body-1 text-ellipsis">{{ stop.serviceTimeMillis | bringozTimeConvert:true }}</span>


        <app-task-detailed-service-time *ngIf="!!stop.detailedServiceTime"
                                        [fontSize]="'br-body-1'"
                                        [isAllowEdit]="false"
                                        [detailedServiceTime]="stop.detailedServiceTime">
        </app-task-detailed-service-time>

      </div>
    </ng-container>

    <!--SLA Row-->
    <div *ngIf="settings?.columns?.sla"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
      <span class="br-body-1 fon-weight-600"
            [ngbTooltip]="'Service Level Agreement' | translate"
            openDelay="300">SLA</span>
      <span class="br-body-1">{{ job | bringozDate: 'sla' }}</span>
      <span class="br-body-1">{{ job | bringozTime: 'sla' }}</span>
    </div>

    <!--Account-->
    <div *ngIf="settings?.columns?.account"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="account"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Account' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-demand-account-link class="flex text-ellipsis"
                               [account]="{name: job.accountName, id: job.accountId}"
                               isAllowCopyButton="true">

      </app-demand-account-link>
    </div>

    <!--Vehicles-->
    <div *ngIf="settings?.columns?.vehicles"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
      <bringoz-icon iconName="privatecar"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Vehicles' | translate"
                    openDelay="300">

      </bringoz-icon>

      <app-bringoz-items-list-display [itemsList]="{list: job.allowedVehicleReferences, displayKey: 'name'}"
                                      maxItems="1">

      </app-bringoz-items-list-display>
    </div>

    <!--Account External ID-->
    <div *ngIf="settings?.columns?.accountExternalId"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="account"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Account External ID' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.accountExternalId || '---' }}</span>
    </div>

    <!--Labels Row-->
    <div *ngIf="settings?.columns?.labels"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="label-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Labels' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-labels-display [labels]="labels"
                                  maxItems="1">

      </app-bringoz-labels-display>
      <span *ngIf="!labels?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Tags Row-->
    <div *ngIf="settings?.columns?.tags"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="tag-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Tags' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-tags ng-if="agent.tags.length"
                        class="margin-left-5"
                        [maxTags]="1"
                        [tags]="job.tags">
      </app-bringoz-tags>
      <span *ngIf="!job.tags?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Skills Row-->
    <div *ngIf="settings?.columns?.skills"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="skill-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Skills' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span *ngIf="!job.skills?.length" class="br-body-1 text-ellipsis">---</span>
      <app-skill-tags class="flex" [skillsIds]="job.skills" limit="1"></app-skill-tags>
    </div>

    <!--Packages-->
    <div *ngIf="settings?.columns?.packages"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-packages-items-display-list class="flex"
                                               [items]="job.packages">

      </app-bringoz-packages-items-display-list>
    </div>


    <!--Leftover Reason-->
    <div
      *ngIf="settings?.columns?.leftoverReason && (!!draft?.jobIdToUnassignedJobData && !!draft.jobIdToUnassignedJobData[job.id])"
      class="layout-row layout-align-start-center info-row gap-5 "
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'">
      <bringoz-icon iconName="info-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Leftover Reason' | translate"
                    openDelay="300">

      </bringoz-icon>
      <ng-template #htmlContent>
        <div class="layout-column layout-align-center-start" style="width: 284px;">
          <div class="layout-row layout-align-start-center" style="width: 100%;"
               *ngFor="let c of draft.jobIdToUnassignedJobData[job.id].failedConstraints">
            <span class="br-body-2 flex-15"
                  style="font-weight: 600 !important;">
              {{ (c.frequencyPercentage * 100).toFixed(0) }}%
            </span>
            <span class="br-body-2 flex" style="text-align: start;">
              {{ 'PLANNING_DRAFT_LEFTOVERS_REASONS.' + c.constraint.name + '.name' | translate }}
            </span>
          </div>
        </div>
      </ng-template>

      <span class="br-body-1 text-ellipsis cursor-help"
            [ngbTooltip]="htmlContent" openDelay="300" triggers="hover">
        {{
          'PLANNING_DRAFT_LEFTOVERS_REASONS.'
          + draft.jobIdToUnassignedJobData[job.id].mostLikelyReason + '.name' | translate
        }}
      </span>

    </div>

    <div *ngIf="!!job.serviceTemplateId && settings?.columns?.recurringServiceTemplateId"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="recurring" class="gray-102" classSize="md"
                    [ngbTooltip]="'Recurring Service Template' | translate"
                    openDelay="300"></bringoz-icon>
      <app-bringoz-state-link class="text-ellipsis"
                              [state]="'recurring-services'"
                              [permission]="'recurring-service-template.list'"
                              [params]="{queryString: job.serviceTemplateId}"
                              [text]="job.serviceTemplateId">
      </app-bringoz-state-link>
    </div>

    <!--Load - Weight-->
    <div *ngIf="settings?.load?.weight"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="weight"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Weight' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesWeightPipe:true }}</span>
    </div>

    <!--Load - Volume-->
    <div *ngIf="settings?.load?.volume"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="volume"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Volume' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesVolumePipe:true }}</span>
    </div>

    <!--Load - Packages-->
    <div *ngIf="settings?.load?.packages"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesPipe:false }}</span>
    </div>

    <!--Load - Value-->
    <div *ngIf="settings?.load?.value"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="dollar-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Value' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.price | bringozPrice }}</span>
    </div>

    <!--Load - Pallets-->
    <div *ngIf="settings?.load?.pallets"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="pallets"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Pallets' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesPalletsPipe: false }}</span>
    </div>

    <!--Load - Spots-->
    <div *ngIf="settings?.load?.spots"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="spot"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Spots' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesSpotsPipe }}</span>
    </div>

  </div>

</div>

<div *ngIf="!!job.groupedByType && !isChild" class="col full-height layout-column">
  <div class="col layout-row"
       [ngClass]="{'selected': isSelected}"
       openDelay="500">

    <div *ngIf="draft" flex class="layout-row gap-10 indications">


    <ng-container *ngTemplateOutlet="dragHandleTemplate"></ng-container>

      <div class="flex layout-column layout-align-center-center gap-5 position-relative">

        <bringoz-icon *ngIf="job.isDisableSelect"
                      class="margin-right-5"
                      iconName="lock"
                      classSize="lg"
                      fill="#484848"
                      [ngbTooltip]="'Job is Locked' | translate"
                      openDelay="300">

        </bringoz-icon>

      </div>
    </div>

    <div class="flex layout-row layout-wrap info-container">
      <!--Link Row-->
      <div class="flex-100 layout-row layout-align-start-center">

        <span class="br-body-1 font-weight-400 id-row layout-row layout-align-start-center">
          <app-bringoz-checkbox class="margin-right-5"
                                [isChecked]="isSelected"
                                [ngbTooltip]="isSelected ? ('Deselect Group' | translate) : ('Select Group' | translate)"
                                openDelay="300"
                                (clickEvent)="onToggleEvent($event)">
          </app-bringoz-checkbox>
          {{
            job.jobIds.length === 1 ? ('X_SERVICE' | translate: {sum: job.jobIds.length})
              : ('X_SERVICES' | translate: {sum: job.jobIds.length})
          }}
        </span>

        <bringoz-button type="tertiary"
                        size="fit"
                        [ngbTooltip]="'View Group Details' | translate"
                        openDelay="300"
                        (onClick)="onViewJob.emit({jobIds: job.jobIds, event: $event})">
          <bringoz-icon iconName="group"
                        fill="#266aff">
          </bringoz-icon>
        </bringoz-button>

        <span class="flex"></span>

        <!--Indexes In Route-->
        <div *ngIf="job.routedCount" class="layout-row gap-2">
          <bringoz-icon iconName="route"
                        fill="#484848">
          </bringoz-icon>
          <span class="br-body-1">{{job.routedCount}}</span>
        </div>

        <bringoz-button class="layout-row gap-2"
                        size="fit"
                        type="tertiary"
                        (onClick)="toggleExpand()">
          <bringoz-icon [iconName]="isGroupExpanded ? 'arrow-up' : 'arrow-down'" classSize="xl"></bringoz-icon>
        </bringoz-button>
      </div>

      <!--Group By - Account-->
      <div *ngIf="job.groupedByType === jobsGroupByTypes.account"
           [ngClass]="itemElementSize === 'medium' ? 'flex-50' : 'flex-100'"
           class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="account"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Account' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ job.accountName }}</span>
      </div>

      <!--Group By - Pickup Location-->
      <div *ngIf="job.groupedByType === jobsGroupByTypes.pickupLocation"
           [ngClass]="itemElementSize === 'medium' ? 'flex-50' : 'flex-100'"
           class="layout-row layout-align-start-center info-row">
        <!--Stops Address-->
        <app-task-purpose [purpose]="'Pickup'" firstLetterOnly="true"></app-task-purpose>
        <div class="flex td small layout-row layout-align-start-center"
             (mouseenter)="onToggleIsShowAddressIcon(job.id + '-Pickup', true)"
             (mouseleave)="onToggleIsShowAddressIcon(job.id + '-Pickup', false)">

          <div *ngIf="!job.depotSyncId" class="flex layout-row layout-align-start-center">

            <span [appBringozTooltip]="locationTooltip"
                  [applyHoverColor]="true"
                  ngbTooltip class="br-body-1 text-ellipsis">
              {{ job.address | bringozAddress }}
            </span>

            <app-address-quality
              *ngIf="isValidAddressType(job.address) && (isShowAddressIcon[job.id + '-Pickup'] || !isHighQualityAddress(job.address))"
              [address]="job.address.addressResolvingInfo" [query]="query"
              [type]="type">
            </app-address-quality>
          </div>


  <!--        <span *ngIf="!job.depotSyncId" class="br-body-1 text-ellipsis"-->
  <!--              [appBringozTooltip]="locationTooltip" [applyHoverColor]="true"-->
  <!--              ngbTooltip>{{ job.address | bringozAddress }}-->
  <!--        </span>-->

          <ng-template #locationTooltip>
            <div class="layout-column layout-align-start-center">
              <div class="layout-column layout-align-start-center">
                <span class="br-body-2">{{ 'Address' | translate }}
                  : {{ job.address | bringozAddress }}</span>
                <div class="layout-column layout-align-start-center">
                  <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}
                    : {{ job.address.floor || '--' }}</span>
                  <span class="br-body-2">{{ 'Apt' | translate }}: {{
                      job.address.apartment || '--'
                    }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <!--Group By - Dropoff Location-->
      <div *ngIf="job.groupedByType === jobsGroupByTypes.dropoffLocation"
           [ngClass]="itemElementSize === 'medium' ? 'flex-50' : 'flex-100'"
           class="layout-row layout-align-start-center info-row">
        <!--Stops Address-->
        <div class="flex td small layout-row layout-align-start-center"
             (mouseenter)="onToggleIsShowAddressIcon(job.id + '-Dropoff', true)"
             (mouseleave)="onToggleIsShowAddressIcon(job.id + '-Dropoff', false)">
          <app-task-purpose [purpose]="'Dropoff'" firstLetterOnly="true"></app-task-purpose>

          <div *ngIf="!job.depotSyncId" class="flex layout-row layout-align-start-center">

            <span [appBringozTooltip]="locationTooltip"
                  [applyHoverColor]="true"
                  ngbTooltip class="br-body-1 text-ellipsis">
              {{ job.address | bringozAddress }}
            </span>

            <app-address-quality
              *ngIf="isValidAddressType(job.address) && (isShowAddressIcon[job.id + '-Dropoff'] || !isHighQualityAddress(job.address))"
              [address]="job.address.addressResolvingInfo" [query]="query"
              [type]="type">
            </app-address-quality>
          </div>

          <ng-template #locationTooltip>
            <div class="layout-column layout-align-start-center">
              <div class="layout-column layout-align-start-center">
                <span class="br-body-2">{{ 'Address' | translate }}
                  : {{ job.address | bringozAddress }}</span>
                <div class="layout-column layout-align-start-center">
                  <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}
                    : {{ job.address.floor || '--' }}</span>
                  <span class="br-body-2">{{ 'Apt' | translate }}: {{
                      job.address.apartment || '--'
                    }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <!--Time Window Row-->
      <div *ngIf="settings?.columns?.timeWindow && !itemElementSize"
           [ngClass]="itemElementSize === 'medium' ? 'flex-50' : 'flex-100'"
           class="layout-row layout-align-start-center info-row">
        <!--Stops Time Window-->
        <div class="flex layout-row layout-align-start-center gap-5 text-ellipsis">
          <bringoz-icon iconName="time-window-outline"
                        classSize="md"
                        fill="#7E7E7E"
                        [ngbTooltip]="'Time Window' | translate"
                        openDelay="300">
          </bringoz-icon>
          <span class="br-body-1 text-ellipsis">{{ job | timeWindow }}</span>

        </div>


      </div>

      <!--Packages-->
      <div *ngIf="settings?.columns?.packages"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="package-outline"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Packages' | translate"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-packages-items-display-list class="flex"
                                                 [items]="job.packages">

        </app-bringoz-packages-items-display-list>
      </div>

      <!--Load - Weight-->
      <div *ngIf="settings?.load?.weight"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="weight"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Weight' | translate"
                      openDelay="300">
        </bringoz-icon>
        <span
          class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesWeightPipe:true }}</span>
      </div>

      <!--Load - Volume-->
      <div *ngIf="settings?.load?.volume"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="volume"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Volume' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span
          class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesVolumePipe:true }}</span>
      </div>

      <!--Load - Packages-->
      <div *ngIf="settings?.load?.packages"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="package-outline"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Packages' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesPipe:false }}</span>
      </div>

      <!--Load - Spots-->
      <div *ngIf="settings?.load?.spots"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="spot"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Spots' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesSpotsPipe }}</span>
      </div>
    </div>

  </div>

  <div flex class="margin-left-30" *ngIf="isGroupExpanded">
    <app-planning-draft-jobs-panel-list-item *ngFor="let jobFromGroup of job.jobs; trackBy: trackByJobId"
                                             [draft]="draft"
                                             [job]="jobFromGroup"
                                             [route]="routeMap[jobFromGroup.id]"
                                             [settings]="settings"
                                             [isChild]="true"
                                             (onToggleObligateTimeWindow)="onToggleObligateTimeWindow.emit({jobIds: $event.jobIds, obligateTimeWindow: $event.obligateTimeWindow})"
                                             (onViewJob)="onViewJob.emit({jobs: $event.jobs, jobIds: $event.jobIds, event: $event.event})"
                                             (onContextMenu)="onContextMenu.emit({event: $event.event, job: $event.job})"
                                             (onReverseJobSplit)="onReverseJobSplit.emit({event: $event.event, job: $event.job})">
    </app-planning-draft-jobs-panel-list-item>
  </div>
</div>

<ng-template #dragHandleTemplate>
  <div class="drag-wrapper">
    <ng-content></ng-content>
  </div>
</ng-template>
